module.exports = __webpack_public_path__ + "static/media/04_MINS-2.0-H-14 1.1221e8dc.svg";